import { StatusAnnouncer } from "../shared/components/feedback/status-announcer.js";
import { Container } from "../shared/components/layout/container.js";
import { AudioErrorDialog } from "../shared/skins/shared/audio/error-dialog.js";
import { PlaybackHotkeys } from "../shared/skins/shared/playback-hotkeys.js";
import { MinimalAudioControls } from "./controls.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn } from "@videojs/utils/style";
//#region src/internal/skins/minimal-audio/skin.tsx
/** @jsxImportSource react */
function MinimalAudioSkin({ children, className, ...props } = {}) {
	return /* @__PURE__ */ jsxs(Container, {
		className: cn("audio-skin", className),
		"data-theme": "minimal",
		"data-preset": "audio",
		...props,
		children: [
			children,
			/* @__PURE__ */ jsx(AudioErrorDialog, {}),
			/* @__PURE__ */ jsx(MinimalAudioControls, {}),
			/* @__PURE__ */ jsx(PlaybackHotkeys, {}),
			/* @__PURE__ */ jsx(StatusAnnouncer, {})
		]
	});
}
//#endregion
export { MinimalAudioSkin };

//# sourceMappingURL=skin.js.map